module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av639-4bf2a718075adf9977d3bceb5d41ae3f.jpg";